import { Component } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import {  HttpParams,  HttpClient } from '@angular/common/http';
import{ GlobalProvider } from '../../providers/global/global';
import { TimesheetlistPage } from '../timesheetlist/timesheetlist';

/**
 * Generated class for the ChangePasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.html',
})
export class ChangePasswordPage {

  pass: AbstractControl;
  pass1: AbstractControl;
  oldpassword: AbstractControl;
  formgroup: FormGroup;
  errorMessage: string = '';
  res: any;
  success: boolean = false;

  constructor(public global: GlobalProvider, public http: HttpClient ,public navCtrl: NavController,
    public formbuilder: FormBuilder) {


    this.formgroup = formbuilder.group({
      oldpassword: ['', Validators.compose([Validators.required])],
      pass: ['', Validators.compose([Validators.minLength(6), Validators.required])],
      pass1: ['', Validators.compose([Validators.minLength(6), Validators.required])]

    });


    this.oldpassword = this.formgroup.controls['oldpassword'];
    this.pass = this.formgroup.controls['pass'];
    this.pass1 = this.formgroup.controls['pass1'];


  }

  changePassword(){
    // Reset error message
    this.errorMessage = '';

    if (this.formgroup.valid) {
      // Check if passwords match
      if(this.pass.value == this.pass1.value){
        this.httpRequest();
      }
      else {
        this.errorMessage = 'New password and confirm password do not match';
      }
    }
    else {
      // Check which fields have errors and set appropriate message
      if(this.oldpassword.hasError('required')) {
        this.errorMessage = 'Old password is required';
      }
      else if(this.pass.hasError('required')) {
        this.errorMessage = 'New password is required';
      }
      else if(this.pass.hasError('minlength')) {
        this.errorMessage = 'Password must be at least 6 characters long';
      }
      else if(this.pass1.hasError('required')) {
        this.errorMessage = 'Please confirm your new password';
      }
    }
  }

  httpRequest(){
    // Reset error message before making the request
    this.errorMessage = '';

    var p : any={};
    p.oldpassword = this.oldpassword.value;
    p.password = this.pass.value;

    const params = new HttpParams().set('j',JSON.stringify(p))

    this.http.post('login/set_password_new/', params)
    .subscribe(data =>
    {
      this.res = data;

      if (this.res.result == true) {
        this.success = true;

        // Navigate to homepage after a short delay to show success message
        setTimeout(() => {
            this.navCtrl.push(TimesheetlistPage);
        }, 1500);

      } else {
        this.errorMessage = "Old password is incorrect";
        this.success = false;
      }
    },
    error =>
    {
      this.errorMessage = "An error occurred. Please try again.";
    });
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad ChangePasswordPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.ts